import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useEffect, useState } from 'react';
import searchIcon from '../../icons/untitled-ui/duocolor/search.svg';

const SearchBox = ({
  setSearchData,
  searchData = '',
  placeholder = '',
  setIsOpen,
  isOpen,
}: any) => {
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    let timerOut: any;
    timerOut = setTimeout(() => {
      setSearchData(searchTerm);
    }, 1500);

    return () => clearTimeout(timerOut);
  }, [searchTerm]);

  return (
    <OutlinedInput
      defaultValue=""
      fullWidth
      value={searchTerm}
      sx={{
        marginRight: '10px',
        width: '96%',
        height: '42px',
        borderRadius: '16px',
      }}
      onClick={() => {
        if (!isOpen) setIsOpen(true);
      }}
      onChange={(event) => setSearchTerm(event.target.value)}
      // inputProps={{ ref: queryRef }}
      placeholder={placeholder}
      startAdornment={
        <InputAdornment position="start">
          <img src={searchIcon} />
        </InputAdornment>
      }
    />
  );
};

export default SearchBox;
